import { useEffect, useRef, useState } from "react";
import { BasicPage } from "../theme/Component/BasicPage"
import { BasicTable, MASK_DATE, MASK_NUMBER } from "../theme/Component/BasicTable";
import { DropDown } from "../theme/Component/DropDown";
import { Modal } from "../theme/Component/Modal";
import useDataBean from "../../core/services/dataBean/useDataBean";
import { _RequestApprovalBpm, _single } from "../../core/services/dataBean/EntityCatalog";
import { toast } from "react-toastify";
import { env } from "../../env";
import { AccountEditor } from "../editor/AccountEditor";
import { ListMenu } from "../theme/Component/ListMenu";
import { HandlerInfoProcess } from "../bpm/config/InfoTramiteComponents/HandlerInfoProcess";
import { SignResume } from "./SignResume";
import usePaginator from "../theme/Component/usePaginator";
import useModal, { MODAL_LG, MODAL_md } from "../theme/Component/hooks/useModal";
import { ExpedienteTRD } from "../expediente/ExpedienteTRD";
import { BasicButton } from "../theme/Component/BasicButton";

export const Approvals = () => {


    const testMode = env.PRINT_LOG ?? false;

    const { instance } = useDataBean(_RequestApprovalBpm);


    const [idAccount, setIDAccount] = useState<number>(_single.getAccountID());
    const [lista, setLista] = useState<any>([]);
    const [bean, setBean] = useState<any>({});
    const [action, setAction] = useState<any>({});
    const [modal, setModal] = useState<any>({ name: 'Aprobación', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const [modalMulti, setModalMulti] = useState<any>({ name: 'Seleccione una o Varias Aprobaciones', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalHistory, setModalHistory] = useState<any>({ name: 'Información del Tramite', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });

    const [filter, setFilter] = useState<any>({});
    const modalRequisito = useModal("Expediente", MODAL_LG);


    useEffect(() => {
        setBean({});
        getLista();
    }, [idAccount])

    useEffect(() => {

        if (action.id === 3) {
            setModalMulti({ ...modalMulti, "view": true })
        }
    }, [action])

    const paginator = usePaginator();

    useEffect(() => {
        getLista()
    }, [paginator.page])

    const getLista = () => {
        let st = 1;
        let filtro: any = {
            State: st
        }
        if (filter.Mnemonic?.length > 1) {
            filtro.Mnemonic = filter.Mnemonic
        }

        instance.getRequestApprovalBpmCatalogRender(paginator.page, 15, filtro).then(
            (resp: any) => {
                let temp = resp.List;
                temp.forEach(element => {
                    if (element.DataBeanProperties.IDApprovaldocument) {
                        element.DataBeanProperties.Name = element.DataBeanProperties.Title + " " + element.DataBeanProperties.Mnemonic;
                        element.DataBeanProperties.AlphaCode = element.DataBeanProperties.consecutive;
                    }
                });
                setLista(temp);
                console.log(resp.NumberOfPages)
                paginator.setPages(resp.NumberOfPages);
                // paginator.setRecords();
            }).catch(err => toast.error(err));
    }


    const head = [
        { title: '#', property: 'IDRequestApprovalBpm', visible: true, mask: MASK_NUMBER },
        { title: 'No. Solicitud', property: 'AlphaCode', visible: true },
        { title: 'Solicitado', property: 'Since', visible: true },
        { title: 'Solicitud', property: 'Name', visible: true },
        { title: 'Estado', property: 'StateName', visible: true },
        { title: 'Observación', property: 'Observation', visible: true },
        { title: 'Fecha Aprobación', property: 'SingDate', visible: true },
        { title: 'Estado Aprobación', property: 'StateName', visible: true },
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Historial del Procedimiento', icono: 'ri-file-chart-line', visible: true, evento: () => { setModalHistory({ ...modalHistory, "view": true }) } },
            { titulo: 'Expediente Adjuntos', icono: ' ri-folder-2-line', visible: true, evento: () => { modalRequisito.open() } },
            { titulo: 'Anular Solicitu de Firmas', icono: ' ri-delete-bin-line', visible: true, evento: () => { setModal({ ...modal, "view": true }) } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const cancelSignedDocument = () => {
        instance.cancelApprovalDocument(bean.IDApprovaldocument).then(
            (resp) => {
                getLista();
                setModal({ ...modal, view: false })
            }
        ).catch(
            err => {
                toast.error(err)
            }
        )
    }

    return (
        <BasicPage titulo="Solicitudes en de Firma en Proceso">
            <div className="row">
                {/* <div className="col-md-4">
                    {testMode &&
                        <AccountEditor idAccount={idAccount} label="Tercero" onChange={(e: any) => { setIDAccount(e.IDAccount) }} />
                    }
                </div> */}
                <div className="col-md-3">
                    <label>Filtro</label>
                    <input type="text" className="form-control" value={filter.Mnemonic} onChange={(e) => { setFilter({ ...filter, "Mnemonic": e.target.value }) }} />
                </div>
                <div className="col-md-3 mt-4">
                    <BasicButton icon="" eventClick={getLista}>Buscar</BasicButton>
                </div>
                <div className="col-md-12">
                    <BasicTable listButtons={listaBotones()} head={head} body={lista} rowSet={setBean} pageTop={paginator.page} next={paginator.next} back={paginator.back} records={paginator} />
                </div>

                <div className="col-md-12">
                    <Modal modal={modal} updateModal={setModal} eventModal={() => { cancelSignedDocument() }}  >
                        ¿Esta Seguro de Anular la solicitud {bean.Name}?
                    </Modal>
                </div>

                <div className="col-md-12">
                    <Modal modal={modalRequisito.modal} updateModal={modalRequisito.setModal}>
                        <ExpedienteTRD typeExpediente="DOCUMENTO" dataExpediente={bean} />
                    </Modal>
                </div>

                <div className="col-md-12">
                    <Modal modal={modalHistory} updateModal={setModalHistory} >
                        {bean.IDApprovaldocument ?
                            <SignResume data={bean} />
                            :
                            <HandlerInfoProcess _ProcedureIMPID={bean.IDProcedureImp} />
                        }
                    </Modal>
                </div>
            </div>
        </BasicPage>
    )
}